import React, { useState, useRef } from 'react';
import { Button, Divider, Form, Input, InputNumber, Modal, Typography } from 'antd';
import { notification } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '@/core/store';
import LoadingCover from '../../components/LoadingCover';
const { Text } = Typography;
import ReCAPTCHA from "react-google-recaptcha";


const UserSignUp = ({ open, handleClose }) => {

    const captchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
    const captchaSecretKey = import.meta.env.VITE_RECAPTCHA_SECRET_KEY;

    const recaptchaRef = React.useRef();


    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const pending = useSelector(state => state.auth.pending);
    const loadSignUpModal = useSelector(state => state.auth.loadSignUpModal);


    const handleSubmitSignUp = async (values) => {

        const captchaValue = recaptchaRef.current.getValue();
        //console.log(captchaValue);

        if (!captchaValue) {
            notification.destroy();
            notification['error']({
                duration: 3,
                message: 'Please verify the reCAPTCHA',
                description: 'Please verify the reCAPTCHA to proceed.',
            });
            return
        } else {
            // proceed with form submission
        }

        dispatch(actions.auth.submitUserSignUp(values, captchaValue));
    };


    const closeModal = () => {
        if (pending) {
            return false;
        }
        dispatch(actions.auth.setState({ loadSignUpModal: false }));
        form.resetFields();
        handleClose();
    };

    const onChangeCAPTCHA = (v) => {
        //console.log('onChangeCAPTCHA')
        //console.log(v)
    }

    const onCAPTCHALoaded = (e) => {
        //console.log('onCAPTCHALoaded')
        //console.log(e)
    }



    return (
        <>
            <Modal
                title={'Request User Account'}
                visible={open}
                centered
                onCancel={closeModal}
                maskClosable={false}
                footer={null}
            >
                {
                    pending &&
                    <LoadingCover />
                }
                <Form
                    className="ts_form_margin"
                    name="submit_signup"
                    form={form}
                    onFinish={handleSubmitSignUp}
                >
                    <Form.Item
                        name="firstName"
                        rules={[{ required: true, message: 'First name is required' }]}
                    >
                        <Input addonBefore="First Name" className="ts_padding" disabled={pending} />
                    </Form.Item>

                    <Form.Item
                        name="lastName"
                        rules={[{ required: true, message: 'Last Name is required' }]}
                    >
                        <Input addonBefore="Last Name" className="ts_padding" disabled={pending} />
                    </Form.Item>

                    <Form.Item
                        name="email"
                        rules={[{ required: true, message: 'Email is required' }]}
                    >
                        <Input addonBefore="Business Email" className="ts_padding" disabled={pending} />
                    </Form.Item>

                    <Form.Item
                        name="company"
                        rules={[{ required: true, message: 'Organization Name is required' }]}
                    >
                        <Input addonBefore='Company' className="ts_padding" disabled={pending} />
                    </Form.Item>
                    <Text>Last Payment Amount:</Text>
                    <Form.Item
                        name="lastPaymentAmount"
                    >
                        <InputNumber addonBefore='$' precision={2} placeholder='0.00' className="ts_padding" disabled={pending} />
                    </Form.Item>

                    <Divider />

                    <div
                        className='reset-pw-captcha-parent'
                        style={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={captchaSiteKey}
                            onChange={onChangeCAPTCHA}
                            asyncScriptOnLoad={onCAPTCHALoaded}
                            size={'normal'}
                        />
                    </div>

                    <Divider />

                    <Button
                        type="primary"
                        htmlType="submit"
                        className="ts_margin_left"
                        disabled={pending}
                    >
                        Send Request
                    </Button>

                    <Button
                        onClick={closeModal}
                        className="ts_margin_left"
                        disabled={pending}
                    >
                        Cancel
                    </Button>

                </Form>
            </Modal>

        </>
    );
};



export default UserSignUp;
